import { createFileRoute } from '@tanstack/react-router';
import AuditEventList from '~/containers/AuditEventList';

export const Route = createFileRoute('/users/$publisherId/audit')({
  component: AuditEventList,
  validateSearch(search): { from?: string } {
    return {
      from: (search.from as string) || undefined,
    };
  },
});
